import { REDUX_ACTIONS } from '../../shared/config/constants';
import { HYDRAULICS_RUN_TYPES } from '../../utils/constants';

const initialState = {
  data: {},
  loading: true,
  errorMessage: '',
  editing: false,
  runType: HYDRAULICS_RUN_TYPES?.HYDRAULICS.typeKey,
  featuredWellRun: {
    results: [],
    run_details: {},
    inputs: [],
    runId: null,
  },
  units: {},
  hydraulicsRunLoading: false,
  hideChartResults: false
};

const hydraulicsLandingReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.HYDRAULICS_LANDING_FEATURED_WELL_RUN_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        units: action.payload.units,
        loading: false,
        errorMessage: ''
      };
    case REDUX_ACTIONS.HYDRAULICS_LANDING_FEATURED_WELL_RUN_LOADING:
      return {
        ...state,
        loading: true,
      };
    case REDUX_ACTIONS.HYDRAULICS_LANDING_FEATURED_WELL_RUN_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload
      };
    case REDUX_ACTIONS.HYDRAULICS_LANDING_SET_FEATURED_WELL_RUN_TYPE: {
      const results = state?.data[action.payload]?.results;

      if (action.payload === HYDRAULICS_RUN_TYPES?.PARAMETRIC_ANALYSIS?.typeKey && results?.length > 0) {
        const listData = results.map((item) => {
          const rawInputs = { ...item.inputs };
          if (rawInputs?.pumping_mw !== undefined) {
            rawInputs.mw = rawInputs.pumping_mw;
            delete rawInputs.pumping_mw;
          }
          return {
            ...item,
            inputs: rawInputs,
          };
        });

        return {
          ...state,
          hideChartResults: false,
          runType: action.payload,
          featuredWellRun: {
            ...state.data[action.payload],
            results: listData
          }
        };
      }

      return {
        ...state,
        hideChartResults: false,
        runType: action.payload,
        featuredWellRun: {
          ...state.data[action.payload]
        }
      };
    }
    case REDUX_ACTIONS.HYDRAULICS_LANDING_SET_FEATURED_WELL_RUN_TYPE_DATA: {
      if (state.runType === HYDRAULICS_RUN_TYPES?.PARAMETRIC_ANALYSIS?.typeKey) {
        const updatedResults = action.payload?.results?.map((item) => {
          const rawInputs = { ...item.inputs };
          if (rawInputs?.pumping_mw !== undefined) {
            rawInputs.mw = rawInputs.pumping_mw;
            delete rawInputs.pumping_mw;
          }
          return {
            ...item,
            inputs: rawInputs,
          };
        });

        return {
          ...state,
          data: {
            ...state.data,
            [state.runType]: {
              ...state.featuredWellRun,
              ...action.payload,
              results: updatedResults
            },
          },
          featuredWellRun: {
            ...state.featuredWellRun,
            ...action.payload,
            results: updatedResults
          },
          hideChartResults: false,
        };
      }

      return {
        ...state,
        data: {
          ...state.data,
          [state.runType]: {
            ...state.featuredWellRun,
            ...action.payload
          },
        },
        featuredWellRun: {
          ...state.featuredWellRun,
          ...action.payload
        },
        hideChartResults: false,
      };
    }
    case REDUX_ACTIONS.HYDRAULICS_LANDING_RUN_LOADING:
      return {
        ...state,
        hydraulicsRunLoading: action.payload
      };
    case REDUX_ACTIONS.HYDRAULICS_LANDING_RUN_INPUTS_CHANGED:
      return {
        ...state,
        hideChartResults: true,
      };
    default:
      return state;
  }
};

export default hydraulicsLandingReducer;
